export class SelectGroup<T> {
  items: T[] = [];

  isSelected(item: T): boolean {
    return this.items.includes(item);
  }

  isAllSelected(items: T[]): boolean {
    return items.every(i => this.isSelected(i));
  }

  setAll(items: T[], selected: boolean) {
    items.forEach(i => this.set(i, selected));
  }

  update(items: T[], compareFn: (a: T, b: T) => boolean) {
    items.forEach(item => {
      let index = this.items.findIndex(i => compareFn(i, item));
      if (index > -1) {
        this.items[index] = item;
      }
    })
  }

  set(item: T, selected: boolean): void {
    if (selected && !this.isSelected(item)) {
      this.items.push(item);
    } else if (!selected && this.isSelected(item)) {
      this.items.splice(this.items.indexOf(item), 1);
    }
  }

  toggle(item: T): void {
    if (this.isSelected(item)) {
      this.set(item, false);
    } else {
      this.set(item, true);
    }
  }

  deselectAll(): void {
    this.items.splice(0, this.items.length);
  }

  private _selectionMode: SelectionMode = SelectionMode.None;
  get selectionMode(): SelectionMode {
    return this._selectionMode;
  }

  set selectionMode(value: SelectionMode) {
    this._selectionMode = value;
    if (!value) {
      this.deselectAll();
    }
  }

  toggleMode(): void {
    if (this.selectionMode === SelectionMode.None) this.selectionMode = SelectionMode.Multiple;
    else this.selectionMode = SelectionMode.None;
  }
}

export enum SelectionMode {
  None,
  Multiple
}
